import styled from 'styled-components'

 const StyledConfiguracoesIntegracoes = styled.div`

    ${props => props.naoConfigurada && `
      opacity: 0.65;
    `}

    ${props => !props.visivel && `
      .card-integracoes {
        border-left: 3px solid #95a3b7;
      }
    `}

    .card-area{
        width: 100%;
        height: 100%;
        position: absolute;
    }
 
    .header-card{
        position: relative;
        margin-top: 15px;
        height: auto;
        min-height: 45px;
      }

    .card-integracoes {
        width: 340px;
        margin-top: 15px;
        margin-left: 15px;
        position: relative;
    }

    .body-card {
        &:not(:last-child) {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: flex-start;
          position: relative;
          margin-top: 2px;
          margin-bottom: 0px;
          width: 100%;
          padding-bottom: 0px;
        }
    }

    .description-label {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: flex-start;
      font-size: 15px;
      font-weight: var(--font-weight-semibold);
      line-height: 1.82;
      position: relative;
      width: 100%;
      text-transform: uppercase;
      color: var(--color-action-default);
      margin-top: 8px;
    }

    .status-label span:first-child {
      font-size: 12px;
      font-weight: var(--font-weight-semibold);
      line-height: 1.82;
      position: relative;
      width: 100%;
      text-transform: uppercase;
      color: #9aa4ad;
    }

    .status-label span:last-child {
      font-size: 12px;
      font-weight: var(--font-weight-semibold);
      line-height: 1.82;
      position: relative;
      width: 100%;
      text-transform: uppercase;      
      color: ${props => props.corStatus.ColorStatusArrow}
    }

    .card-label {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: flex-start;
      width: 50%;
    }

    .card-label span:first-child {
      font-size: 11px;
      font-weight: var(--font-weight-semibold);
      line-height: 1.82;
      color: #9aa4ad;
      width: 100%;
      text-transform: uppercase;
    }

    .card-label span:last-child {
      font-size: 14px;
      font-weight: var(--font-weight-regular);
      line-height: 1.07;
      color: #393939;
    }

    .card-actions {      
      display: flex;
      justify-content: flex-end;
      width: 100%;
      align-items: center;
    }

    .card-actions .icon-button {
      width: 50px;
      margin-right: 8px;
    }

    .card-actions .execute-button {
      width: 100px;
    }

    .background-job-badge {
      font-size: 10px;
      font-weight: var(--font-weight-semibold);
      color: #95a3b7;
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }

    .background-job-label {
      margin-top: 0px;
    }

    .background-job-label span {
      color: #95a3b7 !important;
      font-size: 10px !important;
    }

    .last-execution-error-badge {
      position: absolute;
      top: -5px;
      right: 8px;
      background-color: #ff5e53;
      color: #fff;
      font-size: 10px;
      font-weight: var(--font-weight-semibold);
      text-transform: uppercase;
      letter-spacing: 0.4px;
      padding: 2px 8px;
      border-radius: 10px;
      line-height: 1.6;
      white-space: nowrap;
      z-index: 10;
    }
`

 export default StyledConfiguracoesIntegracoes
